<dx-box width="100%" height="100%" direction="col" class="community-owner-alerts-list-container">
    <dxi-item baseSize="auto">
        <dx-toolbar width="100%" class="toolbar-container">
            <dxi-item location="center">
                <div *dxTemplate class="community-owner-alerts-list-tabs">
                    <dx-tabs
                        [width]="280"
                        class="cc-tabs"
                        [dataSource]="viewModes"
                        [(selectedIndex)]="selectedViewIndex"
                        (onItemClick)="onTabItemClick($event)"
                    ></dx-tabs>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button
                        type="default"
                        text="Add"
                        icon="plus"
                        [width]="70"
                        [visible]="allowAdd"
                        (onClick)="addNew()"
                    ></dx-button>
                </div>
            </dxi-item>
        </dx-toolbar>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate class="community-owner-alerts-list-items dx-theme-border-color">
            <dx-list
                width="100%"
                height="100%"
                pageLoadMode="scrollBottom"
                noDataText="There are no alerts to display"
                selectionMode="none"
                [activeStateEnabled]="false"
                [focusStateEnabled]="false"
                [hoverStateEnabled]="false"
                [dataSource]="displayedAlerts"
            >
                <div *dxTemplate="let data of 'item'" class="community-owner-alert-item dx-theme-border-color">
                    <div class="cc-white-background cc-text-center">
                        <div class="alert-header-row">
                            <dx-toolbar width="100%">
                                <dxi-item location="before">
                                    <div class="align-content">
                                        <strong
                                            [ngClass]="{ 'cc-text-required': data.priority.toLowerCase() === 'high' }"
                                        >
                                            {{ data.subject }}
                                        </strong>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after">
                                    <div>
                                        <dx-button
                                            type="default"
                                            stylingMode="text"
                                            [icon]="iconEdit"
                                            [visible]="data.allowEdit"
                                            (onClick)="onEditClick(data)"
                                        ></dx-button>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </div>
                    <div class="cc-theme-background">
                        <div [innerHTML]="data.text | ccSafeHtml"></div>
                        <div class="alert-footer-row">
                            <dx-toolbar class="cc-theme-background">
                                <dxi-item location="before">
                                    <div *dxTemplate>
                                        Active from:
                                        <br />
                                        <strong>
                                            {{ data.effectiveDate | date: 'MM/dd/yyyy' }}
                                            <span *ngIf="!!data.endDate">
                                                - {{ data.endDate | date: 'MM/dd/yyyy' }}
                                            </span>
                                        </strong>
                                    </div>
                                </dxi-item>
                                <dxi-item location="after">
                                    <div *dxTemplate>
                                        Created by:
                                        <br />
                                        <strong>
                                            <app-user-bio-link
                                                [user]="data.createdBy"
                                                [communityId]="viewData?.communityID"
                                            ></app-user-bio-link>
                                        </strong>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </div>
                </div>
            </dx-list>
        </div>
    </dxi-item>
</dx-box>

<app-community-owner-alerts-editor #alertsEditor (onSuccess)="onAlertSave($event)"></app-community-owner-alerts-editor>
